import { GatewayClientProvider } from './../gateway-client/gateway-client';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

/*
  Generated class for the ProductsProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class MemberProvider {

  constructor(
    public gateway: GatewayClientProvider,
    public http: Http) {
  }

  getMembers() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getMembers()
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    })
  }

  isMemberRead(memberid) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.isMemberRead(memberid)
        .then(() => {
          resolve(true);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  isMemberInterested(productid) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.isProductInterested(productid)
        .then(() => {
          resolve(true);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  registerProductAction(product, url) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.registerProductAction(product, url)
        .then(() => {
          resolve(true);
        }).catch((error) => {
          reject(error);
        })
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/member/member.ts